import {baseUseNotifyStore} from "~/packages/datakode/nuxt-datakode-utils/store/notify.ts";
import {baseUseConfigStore} from "~/packages/datakode/nuxt-datakode-utils/store/config.ts";
import {baseUseUserStore} from "~/packages/datakode/nuxt-datakode-utils/store/user.ts";

export const useNotifyStore = baseUseNotifyStore;
export const useConfigStore = baseUseConfigStore;
export const useUserStore = baseUseUserStore;